module.exports = __webpack_public_path__ + "pc/img/magazine_writer.19aaf811.jpg";